'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SidebarBoxStyled = undefined;

var _templateObject = _taggedTemplateLiteral(['\n        ', '\n      '], ['\n        ', '\n      ']);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactackleCore = require('reactackle-core');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var propTypes = {
  haveToggleButton: _propTypes2.default.bool,
  expanded: _propTypes2.default.bool,
  attachToRight: _propTypes2.default.bool,
  autoCollapsing: _propTypes2.default.bool,
  theme: _propTypes2.default.object
};
var defaultProps = {
  haveToggleButton: false,
  expanded: false,
  attachToRight: false,
  autoCollapsing: false
};
/** Prop Receivers */

var width = function width(_ref) {
  var themeFromProvider = _ref.theme,
      autoCollapsing = _ref.autoCollapsing,
      expanded = _ref.expanded;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var componentPath = theme.reactackle.components.sidebar.sidebar,
      widthChangingBreakpoint = componentPath.widthChangingBreakpoint,
      zIndex = componentPath.zIndex,
      collapsedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.collapsed.width),
      expandedWidthValue = (0, _reactackleCore.getValueString)(componentPath.state.expanded.width);

  if (autoCollapsing) {
    return (0, _styledComponents.css)(['', ' ', ''], expanded ? '\n          width: ' + expandedWidthValue + ';\n          z-index: ' + zIndex + ';\n        ' : 'width: ' + collapsedWidthValue + ';', (0, _reactackleCore.media)(widthChangingBreakpoint)(_templateObject, !expanded ? 'width: ' + collapsedWidthValue + ';' : 'width: ' + expandedWidthValue + ';'));
  } else {
    return (0, _styledComponents.css)(['', ''], expanded ? 'width: ' + expandedWidthValue + ';' : 'width: ' + collapsedWidthValue + ';');
  }
};

var style = function style(_ref2) {
  var themeFromProvider = _ref2.theme,
      attachToRight = _ref2.attachToRight;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var _theme$reactackle$com = theme.reactackle.components.sidebar.sidebar,
      minHeight = _theme$reactackle$com.minHeight,
      zIndex = _theme$reactackle$com.zIndex,
      backgroundColor = _theme$reactackle$com.backgroundColor,
      fontColor = _theme$reactackle$com.fontColor,
      fontSize = _theme$reactackle$com.fontSize,
      lineHeight = _theme$reactackle$com.lineHeight;
  return (0, _styledComponents.css)(['background-color:', ';min-height:', ';color:', ';font-size:', ';line-height:', ';z-index:', ';', ''], backgroundColor, (0, _reactackleCore.getValueString)(minHeight), fontColor, (0, _reactackleCore.getValueString)(fontSize), lineHeight, zIndex, attachToRight ? '\n        left: auto;\n        right: 0;\n      ' : 'left: 0;');
};

var toggleButton = function toggleButton(_ref3) {
  var haveToggleButton = _ref3.haveToggleButton,
      themeFromProvider = _ref3.theme;
  var theme = (0, _reactackleCore.extractThemeOrDefault)(themeFromProvider);
  var height = theme.reactackle.components.sidebar.toggleButton.height;
  return haveToggleButton ? (0, _styledComponents.css)(['padding-top:', ';'], (0, _reactackleCore.getValueString)(height)) : '';
};
/** Styles */


var SidebarBoxStyled = exports.SidebarBoxStyled = _styledComponents2.default.div.withConfig({
  displayName: 'SidebarBoxStyled'
})(['flex-grow:1;display:flex;flex-direction:column;position:fixed;left:0;height:100%;max-height:100%;overflow-x:hidden;overflow-y:auto;', ';', ';', ';', ';'], width, style, toggleButton, (0, _reactackleCore.transition)('width'));

SidebarBoxStyled.propTypes = propTypes;
SidebarBoxStyled.defaultProps = defaultProps;
SidebarBoxStyled.displayName = 'SidebarBoxStyled';